/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Stats_Total_SessionsInputs */

const fr_week_session_stats_total_sessions = /** @type {(inputs: Week_Session_Stats_Total_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions totales`)
};

/**

* @param {Week_Session_Stats_Total_SessionsInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_stats_total_sessions = /** @type {((inputs?: Week_Session_Stats_Total_SessionsInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Stats_Total_SessionsInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_stats_total_sessions(inputs)
});